<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        style="color: black"
        class="download-btn"
        @click="openModal('create')"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="arachnidUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="arachnids"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-arachnid
      :arachnid="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-arachnid
      :key="arachnidUpdateKey"
      :arachnid="selectedArachnid"
      :visible="dialogType === 'update'"
      :id="selectedArachnid.id"
      @close="closeModal"
      v-on:updated-table="updatedList"
      @updateItem="updateItem"
    />
    <delete-arachnid
      :visible="dialogType === 'delete'"
      :arachnid="selectedArachnid"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-arachnid>
  </div>
</template>

<script>
import CreateArachnid from "./CreateArachnid";
import UpdateArachnid from "./UpdateArachnid";
import DeleteArachnid from "./DeleteArachnid";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateArachnid,
    UpdateArachnid,
    DeleteArachnid,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      arachnidUpdateKey: null,
      arachnidList: [],
      isLoading: false,
      dialogType: "",
      selectedArachnid: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "arachnids"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchArachnids", "createArachnid", "updateArachnid"]),
    editArachnid(arachnid) {
      this.selectedArachnid = { ...arachnid };
      this.dialogType = "update";
    },
    // test() {
    //  },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, arachnid) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedArachnid = { ...arachnid };
      }
    },
    openDeleteModal(type, arachnid) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedArachnid = { ...arachnid };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedArachnid = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedArachnid = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createArachnid(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateArachnid(item);
      this.arachnidUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchArachnids()
        .then(() => {
          //      this.$store.commit("setArachnidTypeResults", response.data);
          this.coverages = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    handleSearch(query) {
      this.getSearchquery = query;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
